import { c as _c } from "react/compiler-runtime";
import { BoxProps } from '@chakra-ui/react';
import { BECOME_ADVISOR_LANDING_ILLUSTRATIONS } from '@src/components/sco/Advisors/AdvisorsLandingIllustrations/becomeAdvisorLandingIllustrations';
import { GenericSVG } from '@src/components/sco/GenericLP/GenericSVG';
import React from 'react';
export type BecomeAdvisorIllustrationProps = BoxProps & {
  illustrationIndex: number;
};

/** Animated SVG feature illustration for the become-an-advisor landing page. */
export const BecomeAdvisorIllustration: React.FC<BecomeAdvisorIllustrationProps> = t0 => {
  const $ = _c(6);
  let boxProps;
  let illustrationIndex;
  if ($[0] !== t0) {
    ({
      illustrationIndex,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = illustrationIndex;
  } else {
    boxProps = $[1];
    illustrationIndex = $[2];
  }
  let t1;
  if ($[3] !== boxProps || $[4] !== illustrationIndex) {
    t1 = <GenericSVG idPrefix="balp" illustrationIndex={illustrationIndex} illustrations={BECOME_ADVISOR_LANDING_ILLUSTRATIONS} {...boxProps} />;
    $[3] = boxProps;
    $[4] = illustrationIndex;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};